function AdsNinjaAdUnit(data){

    this.ID_AD_TYPE_GAM_NEW = 3;
    this.ID_AD_TYPE_GAM_VVV = 4;

    this.ID_VIDEO_CONTEXT_INSTREAM     = 1;
    this.ID_VIDEO_CONTEXT_OUTSTREAM    = 2;
    this.ID_VIDEO_CONTEXT_COMPANION    = 3;
    this.ID_VIDEO_CONTEXT_ACCOMPANYING = 4;

    this.ID_VIDEO_REQUEST_MODE_VIDEO   = 1;
    this.ID_VIDEO_REQUEST_MODE_DISPLAY = 2;

    this.ID_USER_ACTIVITY_TYPE_LONGEST_STRETCH_OF_INACTIVITY = 1;
    this.ID_USER_ACTIVITY_TYPE_LAST_RECORDED_ACTIVITY        = 2;
    this.ID_USER_ACTIVITY_TYPE_TOTAL_TIME_INACTIVE           = 3;

    this.ID_REFRESH_MODE_ENCHANCED = 1;
    this.ID_REFRESH_MODE_REGULAR   = 2;

    // Including these properties for backwards compatibility.
    this.zoneName                  = data.zoneName;
    this.zoneGroupName             = data.zoneGroupName;
    this.useAmazon                 = data.useAmazon;
    this.usePrebid                 = data.usePrebid;
    this.adElementId               = data.adElementId;
    this.onPageLoad                = data.onPageLoad;
    this.dynamicInjectionRefresh   = data.dynamicInjectionRefresh;
    this.floating                  = data.floating;
    this.adUnitPath                = data.adUnitPath;
    this.pos                       = data.pos;
    this.sizeArray                 = data.sizeArray;
    this.width                     = data.width;
    this.height                    = data.height;
    this.bidPoolName               = data.bidPoolName;
    this.pageNumber                = data.pageNumber;
    this.__originalAdData          = data.originalAdData || data.__originalAdData;
    //this.prebidBidSentToGAM        = null;
    this.auctionId                 = null;
    this.tid                       = null;

    // Dom elements.
    this.__adZoneRootWrapperElement             = null;
    this.__adZoneRootContainerElement           = null;
    this.__adZoneRootContainerElementHideButton = null;
    this.__adElement                            = null;
    this.__adZoneInlineElement                  = null;
    this.__adZoneElement                        = null;
    this.__adZoneSizeContainerElement           = null;
    this.__adZoneContainerElement               = null;
    this.__usingManualFloatControl              = false;
}

//
// Sets the dimensions for an ad.
AdsNinjaAdUnit.prototype.__setAdDimensions = function(ad, newAdData){

    var width      = 'auto';
    var height     = 'auto';
    var dimensions = null;

    if(ad['customDimensions'] !== null) {

        dimensions = ad['customDimensions'].split('x');

        if(typeof dimensions[0] !== 'undefined' && dimensions[0] !== ''){

            if (dimensions[0].includes('%')) {

                width = dimensions[0];
            }
            else{

                width =`${dimensions[0]}px`;
            }
        }

        if(typeof dimensions[1] !== 'undefined' && dimensions[1] !== ''){

            if(dimensions[1].includes('%')){

                height = dimensions[1];
            }
            else{

                height =`${dimensions[1]}px`;
            }
        }
    }
    else if((ad['dimension'] !== null ) && 'no_size' !== ad['dimension']['dimension']){

        dimensions = ad['dimension']['dimension'].split('x');
        width      = `${dimensions[0]}px`;
        height     = `${dimensions[1]}px`;
    }

    this.width  = width;
    this.height = height;
};

//
// Returns video settings.
AdsNinjaAdUnit.prototype.getVideoSettings = function(){

    return (this.__originalAdData && Object.keys(this.__originalAdData).length > 0 && this.__originalAdData['videoOptions'] && Object.keys(this.__originalAdData['videoOptions']).length > 0) ? this.__originalAdData['videoOptions'] : null;
};

//
// Set the name of the bid Pool for the ad.
AdsNinjaAdUnit.prototype.setBidPoolName = function(bidPoolName){

    this.bidPoolName = bidPoolName;
};

//
// Returns the name of the bid Pool for the ad.
AdsNinjaAdUnit.prototype.getBidPoolName = function(){

    return this.bidPoolName;
};

//
// Returns the page Number for an ad.
AdsNinjaAdUnit.prototype.getPageNumber = function(){

    return this.pageNumber;
};

//
// Returns video settings.
AdsNinjaAdUnit.prototype.getVideoList = function(){

    return (this.__hasAdData() && this.__originalAdData['videoList'] && Object.keys(this.__originalAdData['videoList']).length > 0) ? this.__originalAdData['videoList'] : null;
};

//
// Returns video settings.
AdsNinjaAdUnit.prototype.isDynamicVideo = function(){

    return (this.__hasAdData() && this.__originalAdData['isDynamicVideo']) ? this.__originalAdData['isDynamicVideo'] : false;
};

//
// Validate ad data.
AdsNinjaAdUnit.prototype.__hasAdData = function(){

    return (this.__originalAdData && Object.keys(this.__originalAdData).length > 0);
};

//
// Validate ad data user activity options.
AdsNinjaAdUnit.prototype.hasAdDataUserActivityOptions = function(){

    return (this.__hasAdData() && this.__originalAdData['userActivityOptions'] && Object.keys(this.__originalAdData['userActivityOptions']).length > 0);
};

//
// Validate ad data user activity options.
AdsNinjaAdUnit.prototype.getUserActivityOptions = function(){

    return this.__originalAdData['userActivityOptions'] || null;
};

//
// Validate ad data video options.
AdsNinjaAdUnit.prototype.__hasAdDataVideoOptions = function(){

    return (this.__hasAdData() && this.__originalAdData['videoOptions'] && Object.keys(this.__originalAdData['videoOptions']).length > 0);
};

//
// Determines outstream video support.
AdsNinjaAdUnit.prototype.hasSupportForVideoOutstream = function(){

    return (this.__hasAdData() && this.__hasAdDataVideoOptions() && this.__originalAdData['videoOptions'].hasOwnProperty('context') && this.ID_VIDEO_CONTEXT_OUTSTREAM === this.__originalAdData['videoOptions']['context']['id']);
};

//
// Determines instream video support.
AdsNinjaAdUnit.prototype.hasSupportForVideoInstream = function(){

    return (this.__hasAdData() && this.__hasAdDataVideoOptions() && this.__originalAdData['videoOptions'].hasOwnProperty('context') && this.ID_VIDEO_CONTEXT_INSTREAM === this.__originalAdData['videoOptions']['context']['id']);
};

//
// Determines companion video support.
AdsNinjaAdUnit.prototype.hasSupportForVideoCompanion = function(){

    return (this.__hasAdData() && this.__hasAdDataVideoOptions() && this.__originalAdData['videoOptions'].hasOwnProperty('context') && this.ID_VIDEO_CONTEXT_COMPANION === this.__originalAdData['videoOptions']['context']['id']);
};

//
// Determines accompanying video support.
AdsNinjaAdUnit.prototype.hasSupportForVideoAccompanying = function(){

    return (this.__hasAdData() && this.__hasAdDataVideoOptions() && this.__originalAdData['videoOptions'].hasOwnProperty('context') && this.ID_VIDEO_CONTEXT_ACCOMPANYING === this.__originalAdData['videoOptions']['context']['id']);
};

//
// Determines video Mode.
AdsNinjaAdUnit.prototype.getVideoContextName = function(){

    if(!this.__hasAdData() && this.__hasAdDataVideoOptions() && this.__originalAdData['videoOptions'].hasOwnProperty('context')){

        return false;
    }

    return this.__originalAdData['videoOptions']['context']['name'];
};

//
// Returns true if the video request mode is display.
AdsNinjaAdUnit.prototype.isVideoRequestModeDisplay = function(){

    return (this.__hasAdData() && this.__hasAdDataVideoOptions() && this.__originalAdData['videoOptions'].hasOwnProperty('requestMode') && this.ID_VIDEO_REQUEST_MODE_DISPLAY === this.__originalAdData['videoOptions']['requestMode']['id']);
};

//
// Returns true if the video request mode is video.
AdsNinjaAdUnit.prototype.isVideoRequestModeVideo = function(){

    return (this.__hasAdData() && this.__hasAdDataVideoOptions() && this.__originalAdData['videoOptions'].hasOwnProperty('requestMode') && this.ID_VIDEO_REQUEST_MODE_VIDEO === this.__originalAdData['videoOptions']['requestMode']['id']);
};

// 
// @deprecated
// Determines use of Amazon video player.
AdsNinjaAdUnit.prototype.usesVideoPlayerAmazon = function(){

    return (this.__hasAdData() && this.__hasAdDataVideoOptions() && this.__originalAdData['videoOptions'].hasOwnProperty('requestMode') && this.__originalAdData['videoOptions']['requestMode'].hasOwnProperty('id') && this.ID_VIDEO_REQUEST_MODE_DISPLAY === this.__originalAdData['videoOptions']['requestMode']['id']);
};

//
// @deprecated
// Determines use of Valstream video player.
AdsNinjaAdUnit.prototype.usesVideoPlayerValstream = function(){

    return (this.__hasAdData() && this.__hasAdDataVideoOptions() && this.__originalAdData['videoOptions'].hasOwnProperty('requestMode') && this.__originalAdData['videoOptions']['requestMode'].hasOwnProperty('id') && this.ID_VIDEO_REQUEST_MODE_VIDEO === this.__originalAdData['videoOptions']['requestMode']['id']);
};

//
// Returns the ad's ad unit path.
AdsNinjaAdUnit.prototype.getAdUnitPath = function(){

    return this.adUnitPath;
};

//
// Returns the ad's ad unit path.
AdsNinjaAdUnit.prototype.getName = function(){

    if(this.__hasAdData() && this.__originalAdData.hasOwnProperty('name') && this.__originalAdData['name']){
        
        return this.__originalAdData['name'];
    }

    return null;
};

//
// Determines can remove vendor specific containers.
AdsNinjaAdUnit.prototype.canRemoveVendorSpecificContainers = function(){

    return (this.__hasAdData() && this.__originalAdData['zone'] && typeof this.__originalAdData['zone'] === 'object' && this.__originalAdData['zone'].hasOwnProperty('canRemoveVendorSpecificContainers') && this.__originalAdData['zone']['canRemoveVendorSpecificContainers']);
};

//
// Determines can remove vendor specific containers.
AdsNinjaAdUnit.prototype.canNotUseSpace = function(){

    return (this.__hasAdData() && this.__originalAdData.hasOwnProperty('doNotUseSpace') && this.__originalAdData['doNotUseSpace']);
};

//
// Returns the original ad element ID.
AdsNinjaAdUnit.prototype.getOriginalAdElementId = function(){

    return (this.__hasAdData() && this.__originalAdData.hasOwnProperty('divId') && this.__originalAdData['divId']) ? this.__originalAdData['divId'] : null;
};

//
// Returns the zone's floating priority.
AdsNinjaAdUnit.prototype.getFloatingPriority = function(){

    if(this.__hasAdData() && this.__originalAdData['zone'] && typeof this.__originalAdData['zone'] === 'object' && this.__originalAdData['zone'].hasOwnProperty('floatingPriority') && this.__originalAdData['zone']['floatingPriority'].hasOwnProperty('value')){

        return this.__originalAdData['zone']['floatingPriority']['value'];
    }

    return 2147483647; // Default to max.
};

//
// Returns current ad element dimension.
AdsNinjaAdUnit.prototype.getCurrentDimensions = function(roundUp = true){

    var adElement = document.getElementById(this.adElementId);

    if(!adElement){

        this.__logger.warn(`Unable to find ad element with ID: ${this.adElementId}.`);

        return null;
    }

    var boundingClientRect = adElement.getBoundingClientRect();
    var width              = boundingClientRect.width;
    var height             = boundingClientRect.height;

    if(roundUp){

        // We need integers for player size.
        width  = Math.ceil(width);
        height = Math.ceil(height);
    }

    return {
        width: width,
        height: height,
    };
};

/*
AdsNinjaAdUnit.prototype.setPrebidBidSentToGAM = function(prebidBid){

    this.prebidBidSentToGAM = prebidBid;
}

AdsNinjaAdUnit.prototype.getPrebidBidSentToGAM = function(){

    return this.prebidBidSentToGAM;
}

*/

AdsNinjaAdUnit.prototype.getTid = function(){

    return this.tid;
};

AdsNinjaAdUnit.prototype.setTid = function(){

    this.tid = window.crypto?.randomUUID();
};

AdsNinjaAdUnit.prototype.setAuctionId = function(auctionId){

    this.auctionId = auctionId;
};

AdsNinjaAdUnit.prototype.getAuctionId = function(){

    return this.auctionId;
};

AdsNinjaAdUnit.prototype.getUseAutoScroll = function(){

    return false;

    if(!this.__hasAdData()){

        return false;
    }

    return this.__originalAdData['useAutoScroll'] || false;
};

AdsNinjaAdUnit.prototype.getAdDimensions = function(){

    var width         = 'auto';
    var height        = 'auto';
    var widthNumeric  = null;
    var heightNumeric = null;

    if(!this.__originalAdData || Object.keys(this.__originalAdData).length === 0){

        return {
            width: width,
            height: height,
        };
    }

    if(this.__originalAdData['customDimensions'] !== null) {

        var dimensions = this.__originalAdData['customDimensions'].split('x');

        if(typeof dimensions[0] !== 'undefined' && dimensions[0] !== ''){

            if (dimensions[0].includes('%')) {

                width = dimensions[0];
            }
            else{

                width        =`${dimensions[0]}px`;
                widthNumeric = Number(dimensions[0]);
            }
        }


        if(typeof dimensions[1] !== 'undefined' && dimensions[1] !== ''){

            if(dimensions[1].includes('%')){

                height = dimensions[1];
            }
            else{

                height         =`${dimensions[1]}px`;
                heightNumeric  = Number(dimensions[1]);
            }
        }
    }
    else if((this.__originalAdData['dimension'] !== null ) && 'no_size' !== this.__originalAdData['dimension']['dimension']){

        var dimensions = this.__originalAdData['dimension']['dimension'].split('x');
        width          = `${dimensions[0]}px`;
        height         = `${dimensions[1]}px`;
        widthNumeric   = Number(dimensions[0]);
        heightNumeric  = Number(dimensions[1]);
    }

    return {
        width: width,
        height: height,
        widthNumeric: widthNumeric,
        heightNumeric: heightNumeric,
    };
};

//
// Validate ad data video options.
AdsNinjaAdUnit.prototype.__hasFloatingOptions = function(){

    return (this.__hasAdData() && this.__originalAdData['floatingOptions'] && Object.keys(this.__originalAdData['floatingOptions']).length > 0);
};

/**
 * Returns true if ad can flolat.
 * 
 * @returns {boolean}
 */
AdsNinjaAdUnit.prototype.canFloat = function(){

    return this.__hasFloatingOptions();
};

//
// Returns floating options.
AdsNinjaAdUnit.prototype.getFloatingOptions = function(){

    if(!this.__hasAdData() && this.__hasFloatingOptions()){

        return null;
    }

    return this.__originalAdData['floatingOptions'];
};

//
// Returns floating options.
AdsNinjaAdUnit.prototype.isFloatingModeAlways = function(){

    return (this.getFloatingOptions() !== null && 'always' === this.__originalAdData['floatingOptions']['floatingMode']);
};

//
// Check if floating until viewed.
AdsNinjaAdUnit.prototype.isFloatUntilViewed = function(){

    return (this.getFloatingOptions() !== null && this.__originalAdData['floatingOptions'].hasOwnProperty('floatUntilViewed') && this.__originalAdData['floatingOptions']['floatUntilViewed']);
};

//
// Check if floating until viewed.
AdsNinjaAdUnit.prototype.isClickToFloat = function(){

    return (this.getFloatingOptions() !== null && this.__originalAdData['floatingOptions'].hasOwnProperty('clickToFloat') && this.__originalAdData['floatingOptions']['clickToFloat']);
};

//
// Retruns Root Wrapper element.
AdsNinjaAdUnit.prototype.getRootWrapperElement = function(bustCache = false){

    if(!bustCache && this.__adZoneRootWrapperElement){

        return this.__adZoneRootWrapperElement;
    }

    var rootAdZoneElement        = this.getAdZoneRootContainerElement();
    var adZoneRootWrapperElement = rootAdZoneElement.closest('.an-injected');

    if(!this.__adZoneRootWrapperElement || bustCache){
        
        this.__adZoneRootWrapperElement = adZoneRootWrapperElement;
    }

    return adZoneRootWrapperElement;
};

//
// Returns ad zone root container element.
AdsNinjaAdUnit.prototype.getAdZoneRootContainerElement = function(bustCache = false){

    if(!bustCache && this.__adZoneRootContainerElement){

        return this.__adZoneRootContainerElement;
    }
    
    var originalElementId            = this.adElementId.split("-count-")[0];
    var adZoneRootContainerElementId = `adsninja-ad-zone-${originalElementId}`;
    var adZoneRootContainerElement   = document.getElementById(adZoneRootContainerElementId);

    if(!this.__adZoneRootContainerElement || bustCache){

        this.__adZoneRootContainerElement = adZoneRootContainerElement;
    }
    
    return adZoneRootContainerElement;
};

//
// Returns ad zone root container element.
AdsNinjaAdUnit.prototype.getAdZoneRootContainerElementHideButton = function(bustCache = false){

    if(!bustCache && this.__adZoneRootContainerElementHideButton){

        return this.__adZoneRootContainerElementHideButton;
    }

    var rootAdZoneElement = this.getAdZoneRootContainerElement();

    if(!rootAdZoneElement){

        return null;
    }

    var hideButtons = rootAdZoneElement.getElementsByClassName('an-btn-hide-me');

    if(!hideButtons || hideButtons.length === 0){

        return null;
    }

    var hideButton = hideButtons[0];

    if(!this.__adZoneRootContainerElementHideButton || bustCache){

        this.__adZoneRootContainerElementHideButton = hideButton;
    }
    
    return hideButton;
};

//
// Returns ad zone container element.
AdsNinjaAdUnit.prototype.getAdZoneContainerElement = function(bustCache = false){

    if(!bustCache && this.__adZoneContainerElement){

        return this.__adZoneContainerElement;
    }

    var adZoneContainerElementId = `ad-zone-container-${this.adElementId}`;
    var adZoneContainerElement   = document.getElementById(adZoneContainerElementId);

    if(!this.__adZoneContainerElement || bustCache){

        this.__adZoneContainerElement = adZoneContainerElement;
    }

    return adZoneContainerElement;
};

//
// Returns ad zone size container element.
AdsNinjaAdUnit.prototype.getAdZoneSizeContainerElement = function(bustCache = false){

    if(!bustCache && this.__adZoneSizeContainerElement){

        return this.__adZoneSizeContainerElement;
    }

    var adZoneSizeContainerElementId = `ad-zone-size-container-${this.adElementId}`;
    var adZoneSizeContainerElement   = document.getElementById(adZoneSizeContainerElementId);

    if(!this.__adZoneSizeContainerElement || bustCache){

        this.__adZoneSizeContainerElement = adZoneSizeContainerElement;
    }

    return adZoneSizeContainerElement;
};

//
// Returns ad zone element.
AdsNinjaAdUnit.prototype.getAdZoneElement = function(bustCache = false){

    if(!bustCache && this.__adZoneElement){

        return this.__adZoneElement;
    }

    var adZoneContainerElement = this.getAdZoneContainerElement(bustCache);

    if(!adZoneContainerElement){

        return null;
    }

    var adZoneElement = adZoneContainerElement.getElementsByClassName('ad-zone')[0];

    if(!this.__adZoneElement || bustCache){

        this.__adZoneElement = adZoneElement;
    }

    return adZoneElement;
};

//
// Returns ad zone inline element.
AdsNinjaAdUnit.prototype.getAdZoneInlineElement = function(bustCache = false){

    if(!bustCache && this.__adZoneInlineElement){

        return this.__adZoneInlineElement;
    }

    var adZoneElement = this.getAdZoneElement(bustCache);

    if(!adZoneElement){

        return null;
    }

    var adZoneInlineElement = adZoneElement.getElementsByClassName('ad-zone-inline')[0];

    if(!this.__adZoneInlineElement || bustCache){

        this.__adZoneInlineElement = adZoneInlineElement;
    }

    return adZoneInlineElement;
};

//
// Returns ad element.
AdsNinjaAdUnit.prototype.getAdElement = function(bustCache = false){

    if(!bustCache && this.__adElement){

        return this.__adElement;
    }

    var adElement = document.getElementById(this.adElementId);

    if(!this.__adElement || bustCache){

        this.__adElement = adElement;
    }

    return adElement;
};

//
// Returns ad element ID.
AdsNinjaAdUnit.prototype.getAdElementId = function(){

    return this.adElementId;
};

//
// Returns viewport height.
AdsNinjaAdUnit.prototype.__getViewportHeight = function(){

    return Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
};

//
// Returns pixel distance based on viewport size.
AdsNinjaAdUnit.prototype.__calculateViewportBasedPixelDistance = function(percentage){
    
    return this.__getViewportHeight() * (percentage / 100);
}

//
// Returns true if ad can be found on page
AdsNinjaAdUnit.prototype.isAdOnPage = function(){

    return (!!this.getAdElement(true));
}

//
// Get height property for floating ad.
AdsNinjaAdUnit.prototype.getFloatingAdHeightProperty = function(){
    
    var heightProperty = 'minHeight';

    if(this.getUseAutoScroll() || 'always' === this.isFloatingModeAlways() || this.usesVideoPlayerValstream()){

        heightProperty = 'height';
    }

    return heightProperty;
}

//
// Determines if ad is featured video player.
AdsNinjaAdUnit.prototype.hasAutoplayAndIsOutstreamWithFloating = function(){
    
    return (this.usesVideoPlayerValstream() && this.__originalAdData['videoOptions']['allowAutoplay'] && this.hasSupportForVideoOutstream() && this.__hasFloatingOptions());
}

//
// Get using manual float control.
AdsNinjaAdUnit.prototype.getUsingManualFloatControl = function(){

    return this.__usingManualFloatControl;
}

//
// Set using manual float control.
AdsNinjaAdUnit.prototype.setUsingManualFloatControl = function(usingManualFloatControl){

    this.__usingManualFloatControl = usingManualFloatControl;
}

//
// Check refresh property.
AdsNinjaAdUnit.prototype.getRefreshProperty = function(property){

    if(!this.__hasAdData() || !this.__originalAdData['refreshOptions'] || !this.__originalAdData['refreshOptions'].hasOwnProperty(property)){

        return null;
    }

    return this.__originalAdData['refreshOptions'][property];
}

//
// Is refresh mode regular.
AdsNinjaAdUnit.prototype.isRefreshModeRegular = function(){

    var mode = this.getRefreshProperty('mode');

    if(!mode){

        return false;
    }

    return (mode.id === this.ID_REFRESH_MODE_REGULAR);
}

//
// Is refresh mode enchanced.
AdsNinjaAdUnit.prototype.isRefreshModeEnchanced = function(){

    var mode = this.getRefreshProperty('mode');

    if(!mode){

        return false;
    }

    return (mode.id === this.ID_REFRESH_MODE_ENCHANCED);
}

//
// Create content and header from templates.
AdsNinjaAdUnit.prototype.createContentAndHeader = function(){

    if(!this.__hasAdData() || !this.__originalAdData['templates']){

        return null;
    }

    var content = this.__originalAdData.templates.contentTemplateInMainContainer;
    var header  = this.__originalAdData.templates.headerTemplate;

    if(typeof header === 'string'){

        header = header.replaceAll('DIR_AD_ELEMENT_ID', this.adElementId);
    }

    if(typeof content === 'string'){

        content = content.replaceAll('DIR_AD_ELEMENT_ID', this.adElementId);
    }

    return {
        'content': content,
        'header': header,
    };
}

//
// Returns repeatable settings.
AdsNinjaAdUnit.prototype.getRepeatableSettings = function(){
    
    return (this.__hasAdData() && this.__originalAdData['repeatableRule'] && Object.keys(this.__originalAdData['repeatableRule']).length > 0) ? this.__originalAdData['repeatableRule'] : null;
}

//
// Returns true id ad in zone is frontend injectable.
AdsNinjaAdUnit.prototype.isFrontendInjectable = function(){
    
    return (this.__hasAdData() && this.__originalAdData['zone'] && this.__originalAdData['zone']['isFrontEndInjectable']);
}

//
// Returns true id ad in zone is frontend injectable.
AdsNinjaAdUnit.prototype.isFrontendInjectableWithInjector = function(){
    
    return (this.isFrontendInjectable() && 'Infinite Scroll Rail' !== this.__originalAdData['zone']['name']);
}

//
// Get estimated x position.
AdsNinjaAdUnit.prototype.getEstimatedYPositionTop = function(){
    
    var rootAdZoneElement = this.getRootWrapperElement();
    if (rootAdZoneElement && rootAdZoneElement.dataset)  {
        var estimatedYTop     = rootAdZoneElement.dataset.estimatedYTop;
        estimatedYTop         = (estimatedYTop) ? parseFloat(estimatedYTop) : null;

        return estimatedYTop || null;
    }

    return null;
};

//
// Get estimated y position.
AdsNinjaAdUnit.prototype.getEstimatedYPositionBottom = function(){
    
    var rootAdZoneElement = this.getRootWrapperElement();

    if (rootAdZoneElement && rootAdZoneElement.dataset)  {
        var estimatedYBottom  = rootAdZoneElement.dataset.estimatedYBottom;
        estimatedYBottom      = (estimatedYBottom) ? parseFloat(estimatedYBottom) : null;

        return estimatedYBottom || null;
    }

    return null;
};

//
// Get estimated x position.
AdsNinjaAdUnit.prototype.getEstimatedXPositionLeft = function(){
    
    var rootAdZoneElement = this.getRootWrapperElement();

    if (rootAdZoneElement && rootAdZoneElement.dataset)  {
        var estimatedXLeft    = rootAdZoneElement.dataset.estimatedXLeft;
        estimatedXLeft        = (estimatedXLeft) ? parseFloat(estimatedXLeft) : null;

        return estimatedXLeft || null;
    }

    return null;
};

//
// Get estimated x position.
AdsNinjaAdUnit.prototype.getEstimatedXPositionRight = function(){
    
    var rootAdZoneElement = this.getRootWrapperElement();

    if (rootAdZoneElement && rootAdZoneElement.dataset)  {
        var estimatedXRight   = rootAdZoneElement.dataset.estimatedXRight;
        estimatedXRight       = (estimatedXRight) ? parseFloat(estimatedXRight) : null;
        
        return estimatedXRight || null;
    }
    return null;
};

//
// Returns parent zone name.
AdsNinjaAdUnit.prototype.getParentZoneName = function(){
    
    if(!this.__hasAdData()){

        return null;
    }

    var zone = this.__originalAdData.zone || null;

    if(!zone || !zone.hasOwnProperty('parent') || !zone.parent || !zone.parent.hasOwnProperty('name')){

        return null;
    }

    return zone.parent.name || null;
}

//
// Returns Prebid ad unit templates.
AdsNinjaAdUnit.prototype.getPrebidAdUnitTemplates = function(){
  
    if(!this.__hasAdData()){

        return null;
    }

    return this.__originalAdData.prebidAdUnitTemplates || null;
};

//
// Returns Amazon ad unit templates.
AdsNinjaAdUnit.prototype.getAmazonAdUnitTemplate = function(){

    return (this.__hasAdData() && this.__originalAdData['amazonAdUnitTemplate']) ? this.__originalAdData['amazonAdUnitTemplate'] : null;
};

//
// Returns renderer.
AdsNinjaAdUnit.prototype.getRenderer = function(){

    return (this.__hasAdData() && this.__originalAdData['renderer']) ? this.__originalAdData['renderer'] : null;
}

//
// Returns bidType.
AdsNinjaAdUnit.prototype.getBidType = function(){

    return (this.__hasAdData() && this.__originalAdData['bidType']) ? this.__originalAdData['bidType'] : null;
}

/**
 * Returns true if the unit will always float.
 * 
 * @returns {boolean}
 */
AdsNinjaAdUnit.prototype.isAlwaysFloating = function(){
    
    return this.isFloatingModeAlways();
};

/**
 * Returns true if zone is not using space.
 * 
 * @returns {boolean}
 */
AdsNinjaAdUnit.prototype.isNotUsingSpace = function(){
    
    return this.canNotUseSpace();
};

/**
 * Returns true if zone is used for an instream video player.
 * 
 * @returns {boolean}
 */
AdsNinjaAdUnit.prototype.isInstreamVideo = function(){
    
    return this.hasSupportForVideoInstream();
};

/**
 * Returns true if zone is used for a video player.
 * 
 * @returns {boolean}
 */
AdsNinjaAdUnit.prototype.isVideo = function(){
    
    return this.__hasAdDataVideoOptions();
};

/**
 * Returns the estimated ad space.
 * 
 * @returns {number}
 */
AdsNinjaAdUnit.prototype.getEstimatedAdSpace = function(includeFloating = true){
    
    var adSpace   = 0;
    var adHeights = [];

    // Get unit dimensions. Either normal or custom.
    var dimensions = this.getAdDimensions();

    if(dimensions && dimensions.height.indexOf('px') !== -1 && dimensions.heightNumeric){

        adHeights.push(dimensions.heightNumeric);
    }

    // Get expected ad sizes.
    this.sizeArray.forEach(function(size){

        adHeights.push(size[1]);
    });

    // Check floating options.
    var floatingOptions = this.getFloatingOptions();

    if(floatingOptions && includeFloating){

        if(floatingOptions.useCloseButton && window.adsNinjaHeaderBiddingManager.isMobile()){

            // Moble close button is different.
            adSpace += 22;
        }

        if(this.isAlwaysFloating()){

            adSpace += (floatingOptions.heightFloating) ? floatingOptions.heightFloating : dimensions.heightNumeric;
        }
        else if(floatingOptions){

            // Floating ad has an origin. Add flaoting height to adSpace.
            adSpace += (floatingOptions.heightFloating) ? floatingOptions.heightFloating : maxHeight;
        }
    }

    if(this.isNotUsingSpace()){
        
        return adSpace;
    }

    if(!this.usesVideoPlayerValstream() || (!dimensions && this.usesVideoPlayerValstream())){

        // Get max height.
        var maxHeight = Math.max.apply(null, adHeights);
        adSpace       += maxHeight;
    }
    else{

        adSpace += dimensions.heightNumeric;
    }

    // TODO: Video player.
    if(this.isInstreamVideo()){

        return adSpace;
    }

    // // Check if has remove ads button.
    // if(!this.isNotUsingSpace() && !this.usesVideoPlayerValstream()){ // TODO: Config.

    //     adSpace += 10; // TODO: Config.
    // }

    // Padding top.
    adSpace += 16; // TODO: Config.

    // Padding bottom.
    adSpace += 16; // TODO: Config.

    // Margin top.
    adSpace += 12; // TODO: Config.

    // Margin bottom.
    adSpace += 12; // TODO: Config.

    // Border top.
    adSpace += 1; // TODO: Config.

    // Border bottom.
    adSpace += 1; // TODO: Config.

    // Root padding top.
    adSpace += 1; // TODO: Config.

    // Root padding bottom.
    adSpace += 1; // TODO: Config.

    return adSpace; // TODO: Fix.
};

/**
 * Returns the current ad space.
 * 
 * @param {boolean} includeFloating
 * @returns {number}
 */
AdsNinjaAdUnit.prototype.getCurrentAdSpace = function(includeFloating = true){
    
    var adSpace = 0;

    if(this.isNotUsingSpace()){
        
        return adSpace;
    }

    var rootContainerElement = this.getAdZoneRootContainerElement();

    if(!rootContainerElement){
        
        return adSpace;
    }

    adSpace = rootContainerElement.getBoundingClientRect().height;

    // Check floating options.
    var floatingOptions = this.getFloatingOptions();

    if(floatingOptions && includeFloating){

        if(floatingOptions.useCloseButton && window.adsNinjaHeaderBiddingManager.isMobile()){

            // Moble close button is different.
            adSpace += 22;
        }

        if(this.isAlwaysFloating()){

            adSpace += (floatingOptions.heightFloating) ? floatingOptions.heightFloating : dimensions.heightNumeric;
        }
        else if(floatingOptions){

            // Floating ad has an origin. Add flaoting height to adSpace.
            adSpace += (floatingOptions.heightFloating) ? floatingOptions.heightFloating : maxHeight;
        }
    }

    // // Check if has remove ads button.
    // if(!this.isNotUsingSpace() && !this.usesVideoPlayerValstream()){ // TODO: Config.

    //     adSpace += 10; // TODO: Config.
    // }

    return adSpace;
};

/**
 * Remove cache.
 */
AdsNinjaAdUnit.prototype.removeCache = function(){

        // Dom elements.
    this.__adZoneRootWrapperElement             = null;
    this.__adZoneRootContainerElement           = null;
    this.__adZoneRootContainerElementHideButton = null;
    this.__adElement                            = null;
    this.__adZoneInlineElement                  = null;
    this.__adZoneElement                        = null;
    this.__adZoneSizeContainerElement           = null;
    this.__adZoneContainerElement               = null;
};

/**
 * Returns the ad zone events log.
 * 
 * @param {string} adElementId 
 * @returns {object}
 */
AdsNinjaAdUnit.prototype.getAdZoneEventsLog = function(){

    return (window.adsNinjaHeaderBiddingManager && window.adsNinjaHeaderBiddingManager.adZoneEventsLog && window.adsNinjaHeaderBiddingManager.adZoneEventsLog.hasOwnProperty(this.adElementId)) ? window.adsNinjaHeaderBiddingManager.adZoneEventsLog[this.adElementId] : null;
}

/**
 * Returns true if the current creative has been loaded.
 * 
 * @returns {boolean}
 */
AdsNinjaAdUnit.prototype.hasCreativeBeenLoaded = function(){
    
    // TODO: Change ownership.
    // return this.__hasBeenLoaded;

    var adZoneEventsLog = this.getAdZoneEventsLog();

    return (!!(adZoneEventsLog && adZoneEventsLog['isLoaded']));
};

/**
 * Returns true if the current creative has been viewed.
 * 
 * @returns {boolean}
 */
AdsNinjaAdUnit.prototype.hasCreativeBeenViewed = function(){
    
    // TODO: Change ownership.
    // return this.__hasBeenViewed;

    var adZoneEventsLog = this.getAdZoneEventsLog();

    return (!!(adZoneEventsLog && adZoneEventsLog['isViewed']));
};

/**
 * Returns true if the current creative's minimum timer has completed.
 * 
 * @returns {boolean}
 */
AdsNinjaAdUnit.prototype.hasCreativeMinimumTimerCompleted = function(){
    
    // TODO: Sepearate concepts of unit and creative.
    // A unit may have multiple creatives.
    // A zone may have multiple units.
    // This is dependent on refresh logic.

    // TODO: Change ownership.
    // return this.__hasBeenLoaded;

    var adZoneEventsLog = this.getAdZoneEventsLog();

    return (!!(adZoneEventsLog && adZoneEventsLog['isMinimumTimerComplete']));
};

window.AdsNinjaAdUnit = AdsNinjaAdUnit;
